import { memo, useContext } from "react";
import { BoletoContext } from "../../../contexts/BoletoContext";
import { BoletoHeaderStyle } from "../../../styles/Boleto";
import ContractDate from "./ContractDate";
import ContractNumber from "./ContractNumber";
import ContractStatus from "./ContractStatus";

const BoletoHeader = () => {
  const { contractData, hasError } = useContext(BoletoContext);
  const { contract } = contractData ?? {};
  return (
    <BoletoHeaderStyle>
      <p>
        Contratos - <strong>2ª Via do Boleto</strong>
      </p>
      <ContractNumber />
      <ContractStatus status={contract?.status} hasError={hasError} />
      <ContractDate date={contract?.renewalDate} hasError={hasError} />
    </BoletoHeaderStyle>
  );
};

export default memo(BoletoHeader);
